<template>
  <div class="container admin-wrapper">
    <b-row>
      <b-col cols="0" lg="4" class="d-none d-lg-block">
        <admin-dash-board-side-menu></admin-dash-board-side-menu>
      </b-col>
      <b-col cols="12" lg="8" >
        <transition name="fade">
          <router-view />
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AdminDashBoardSideMenu from "./components/adminDashBoardSideMenu";
import { mapGetters } from "vuex";
import AdminHome from "./views/adminHome";

export default {
  components: {
    AdminHome,
    AdminDashBoardSideMenu
  },
  name: "Admin",
  computed: {
    ...mapGetters("user", [
      "getUserDetails",
      "getTeacherCourses",
      "getTeacherLiveCourses",
      "isAuthenticated"
    ])
  },
  methods: {
    toggleBusy() {
      this.isBusy = !this.isBusy;
    }
  },
  watch: {
    isAuthenticated() {
      if (!this.isAuthenticated) {
        location.reload(true);
      }
    }
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s cubic-bezier(0.08, 0.61, 0.25, 0.91);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
